
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"colsConnector"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"object_colsConnector"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"object_colsConnector"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cols"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"teaser"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"listing"},"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"element"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"asset"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullpath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filename"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"images"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactWrapper"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"offsetBase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offsetSM"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offsetMD"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offsetLG"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offsetXL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spanBase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spanSM"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spanMD"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spanLG"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spanXL"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":684}};
    doc.loc.source = {"body":"fragment colsConnector on object_colsConnector {\n    ... on object_colsConnector {\n        cols {\n            item {\n                ...teaser\n                ...listing\n                ... on element {\n                    ... on asset {\n                        fullpath\n                        id\n                        filename\n                    }\n                }\n                ...images\n                ...contactWrapper\n            }\n            offsetBase\n            offsetSM\n            offsetMD\n            offsetLG\n            offsetXL\n            spanBase\n            spanSM\n            spanMD\n            spanLG\n            spanXL\n        }\n        headline\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["colsConnector"] = oneQuery(doc, "colsConnector");
        
